module.exports = __webpack_public_path__ + "img/part4-icon2.877817e6.png";